import { Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UiBadgeComponent } from '../badge/ui-badge.component';

@Component({
  selector: 'ui-beta-banner',
  standalone: true,
  imports: [RouterLink, UiBadgeComponent],
  template: `
    <div class="ui-beta-banner">
      <span>{{ message() }}</span>
      <ui-badge variant="brand">Beta</ui-badge>
      @if (preferencesLink()) {
        <a
          [routerLink]="preferencesLink()!"
          [queryParams]="preferencesQueryParams()"
          class="ui-beta-banner__link"
        >{{ preferencesLabel() }}</a>
      }
      @if (showRevert()) {
        <button type="button" class="ui-beta-banner__link" (click)="revertClicked.emit()">
          {{ revertLabel() }}
        </button>
      }
    </div>
  `,
  styles: [`
    .ui-beta-banner {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding: 0.5rem 1rem;
      background: linear-gradient(
        90deg,
        color-mix(in srgb, var(--brand-primary) 14%, transparent) 0%,
        color-mix(in srgb, var(--brand-secondary, #52c41a) 10%, transparent) 100%
      );
      border-bottom: 1px solid var(--border-color);
      border-left: 3px solid var(--brand-secondary, #52c41a);
      font-size: 0.875rem;
    }

    .ui-beta-banner__link {
      margin-left: auto;
      color: var(--brand-primary);
      text-decoration: underline;
      cursor: pointer;
      background: none;
      border: none;
      font-size: inherit;
    }
  `],
})
export class UiBetaBannerComponent {
  message = input('Você está testando o novo layout');
  preferencesLink = input<string | null>('/configuracoes');
  preferencesQueryParams = input<Record<string, string>>({ tab: 'aparencia' });
  preferencesLabel = input('Preferências de interface');
  showRevert = input(true);
  revertLabel = input('Voltar ao clássico');

  revertClicked = output<void>();
}
